import { render, staticRenderFns } from "./User.VerificationComments.vue?vue&type=template&id=1bdc11b0&scoped=true&"
import script from "./User.VerificationComments.vue?vue&type=script&lang=js&"
export * from "./User.VerificationComments.vue?vue&type=script&lang=js&"
import style0 from "./User.VerificationComments.vue?vue&type=style&index=0&id=1bdc11b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdc11b0",
  null
  
)

export default component.exports